/** @flow **/
import * as React from 'react'
import Form from 'Core/Form'
import { formFields } from './config'

const FormExampleForm = () => <Form {...formFields}/>

export default FormExampleForm